import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import translations from '@translationKeys'
import { Nullable } from '@types'

import RadioList from '@components/RadioList'
import { useShortlists } from '@modules/shortlist/hooks/useShortlistMap'
import { Shortlist } from '@modules/shortlist/types'
import { Box, Divider, Typography } from '@mui/material'
import { useFeatureFlags } from '@shared/hooks/useFeatureFlags'

import AddNewShortlistSection from '../AddNewShortlistSection'

const ShortlistSelectionView = ({
  onCancel,
  goBack,
  onSubmit,
}: {
  onCancel: (value: string) => boolean
  goBack: () => void
  onSubmit: (shId: Shortlist['id']) => void
}) => {
  const { t } = useTranslation()
  const [selectedShortlistId, setSelectedShortlistId] = useState<Nullable<string>>(null)

  const { canAddShortlists, rawShortlists, isUniqueName } = useShortlists()

  const { hasAccessToMultipleShortlists } = useFeatureFlags()

  const shortlistOptions = rawShortlists.map(i => ({ value: String(i.id), label: i.name }))

  const hideInput = !canAddShortlists

  return (
    <Box display="flex" maxHeight="100%" flexDirection="column" width="329px">
      <AddNewShortlistSection
        selectable={hasAccessToMultipleShortlists}
        checked={!selectedShortlistId}
        onSelect={() => {
          setSelectedShortlistId(null)
        }}
        title={t(translations.ADD_PROSPECTS_TO_CUSTOM_LIST)}
        subTitle={hasAccessToMultipleShortlists ? t(translations.NEW_LIST) : undefined}
        shortlists={rawShortlists}
        isUniqueName={isUniqueName}
        onCancel={onCancel}
        middleButtonText={t(translations.COMMON_GO_BACK) || ''}
        middleButtonOnClick={goBack}
        onChange={(val: string) => !!val && setSelectedShortlistId(null)}
        submitButtonText={t(translations.CONFIRM_BUTTON) as string}
        onSuccess={(sh?: Shortlist) => onSubmit(Number(selectedShortlistId) || (sh?.id as number))}
        isSubmitButtonEnabled={!!selectedShortlistId}
        hideInput={hideInput}
      >
        {!!rawShortlists?.length && (
          <Box paddingTop="20px" overflow="hidden">
            <Typography variant="caption">{t(translations.ADD_TO_EXISTING_LIST)}</Typography>
            <Divider sx={{ margin: '10px 0' }} />
            <RadioList
              width="100%"
              height="126px"
              overflow="auto"
              paddingBottom="20px"
              value={selectedShortlistId}
              onChange={setSelectedShortlistId}
              items={shortlistOptions}
              alignLeft
            />
          </Box>
        )}
      </AddNewShortlistSection>
    </Box>
  )
}

export default ShortlistSelectionView
